module.exports = __webpack_public_path__ + "img/nagmehkarimi.eb45febd.jpg";